module.exports = __webpack_public_path__ + "static/media/home-image.0a983d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-image.png
// module id = 246
// module chunks = 2